import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class CardHorizontalBlock extends PureComponent {
  static displayName = 'CardHorizontalBlock'

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
  }

  render() {
    const {
      children,
      className,
      ...otherProps,
    } = this.props
    const cssClasses = classNames('mdc-card__horizontal-block', className)
    return (
      <div
        {...otherProps}
        className={cssClasses}
      >
        {children}
      </div>
    )
  }
}

export default CardHorizontalBlock



// WEBPACK FOOTER //
// ./src/Card/CardHorizontalBlock.js